module.exports = __webpack_public_path__ + "img/yiduiyi-banner.754f3562.jpg";